import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet } from 'react-native';


export const Edit = ({ navigation }) => {
  const navigateDetails = () => {
    navigation.navigate('Details');
  };

  return (
      <Layout level='2' style={{flex:1}}>
      <Button
        style={styles.button}
        size='small'
        appearance='outline'>
          سلام
      </Button>
      <Button
        style={styles.button}
        size='small'
        appearance='outline'>
          سلام
      </Button>

      </Layout>
  );
};

const styles = StyleSheet.create({

  button: {
  maxWidth:170,
  height:40,
  marginVertical:5,
  marginHorizontal:15,
  borderRadius:50
  },
});
